import { CommandBarButton, IButtonStyles } from "@fluentui/react";
import React from "react";

const buttonStyles = (selected: boolean): Partial<IButtonStyles> => ({
    root: {
        whiteSpace: "nowrap",
        outline: "transparent",
        position: "relative",
        WebkitFontSmoothing: "antialiased",
        fontSize: 14,
        border: 0,
        borderRadius: 0,
        boxSizing: "border-box",
        cursor: "pointer",
        display: "inline-block",
        alignItems: "center",
        justifyContent: "center",
        padding: "0 8px",
        textDecoration: "none",
        textAlign: "center",
        height: 44,
        color: selected ? "#0078d4" : "#323130",
        background: "transparent",
        lineHeight: "44px",
        marginRight: 8,
        userSelect: "none",
        "::before": {
            backgroundColor: selected ? "#0078d4" : "transparent",
            bottom: 0,
            content: '""',
            height: 2,
            left: 12,
            right: 12,
            position: "absolute",
            transition:
                "left 0.267s cubic-bezier(0.1, 0.25, 0.75, 0.9), right 0.267s cubic-bezier(0.1, 0.25, 0.75, 0.9)"
        },
        ...(selected && {
            ":hover::before": {
                left: 0,
                right: 0
            }
        }),
        "::after": {
            color: "transparent",
            content: "attr(data-content)",
            display: "block",
            fontWeight: 700,
            height: 1,
            overflow: "hidden",
            visibility: "hidden"
        }
    },
    label: {
        zIndex: 1,
        fontWeight: selected ? 600 : 500
    }
});

export interface AnimatedCommandBarButtonProps {
    text: string;
    selected?: boolean;
    onClick?: () => void;
}

export const AnimatedCommandBarButton = ({
    text,
    onClick,
    selected = false
}: AnimatedCommandBarButtonProps): JSX.Element => (
    <CommandBarButton checked={selected} styles={buttonStyles(selected)} onClick={onClick} text={text} />
);
